module.exports = __webpack_public_path__ + "static/img/10001 (4).d0e25a9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10001 (4).webp
// module id = nyWz
// module chunks = 14